import AppPageHeader from '@/components/_common/AppPageHeader';
import {
  ListStockItemsQuery,
  StockItemType,
} from '@/core/domain/stock/StockItems/StockItems.types';
import { ExtraFiltersProps } from '@/types/ExtraFiltersProps';

interface Props extends ExtraFiltersProps<ListStockItemsQuery> {
  itemType?: StockItemType;
  extraFilters?: React.ReactElement;
}

const FiltersItemsStockModal: React.FC<Props> = ({
  setQueryParams,
  extraFilters,
}) => {
  return (
    <AppPageHeader
      onSearch={(value: string) =>
        setQueryParams((prev) => ({ ...prev, search: value }))
      }
      extraFilters={extraFilters}
    />
  );
};

export default FiltersItemsStockModal;
